module.exports = __webpack_public_path__ + "img/card_feature_2_grand_cherokee.eeff3643.jpg";